/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ConfigProvider, theme } from "antd";
import {
  getCurrentUser,
  getIsTemporalPassword,
  getTokenData,
  isAuthenticated,
} from "security";
import configureStore from "store/configureStore";
import { MyDistributionPoint } from "context/MyDistributionPoint";
import Routes from "routes/Routes";
import Login from "containers/login";
import RedemptionCodeComponent from "routes/subscriptions/redemptionCode/redemptionCodeComponent";
import "antd/dist/reset.css";
import "./styles/index.css";
import { getMenu } from "common/components/layout/menu/Menu";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const Router = (props: any) => {
  const { menu, userData } = props;
  return (
    <MyDistributionPoint>
      <Provider store={configureStore({ userData })}>
        {<Routes menu={menu} />}
      </Provider>
    </MyDistributionPoint>
  );
};

const AppContent: React.FC = () => {
  const isTemporalPassword = getIsTemporalPassword();
  if (isAuthenticated()) {
    const userData: any = getCurrentUser();
    const tokenData: any = getTokenData();
    const providerDataOrigin = tokenData?.providerDataOrigin;
    if (isTemporalPassword === "true") {
      return (
        <RedemptionCodeComponent>
          <Login isTemporalPassword />
        </RedemptionCodeComponent>
      );
    } else {
      return (
        <RedemptionCodeComponent>
          <Router
            {...{
              userData,
              menu: getMenu(userData.permissions, providerDataOrigin),
            }}
          />
        </RedemptionCodeComponent>
      );
    }
  } else {
    return (
      <RedemptionCodeComponent>
        <Login isTemporalPassword={false} />
      </RedemptionCodeComponent>
    );
  }
};

const App: React.FC = () => {
  return (
    <ConfigProvider
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: "#33aadd",
          colorInfo: "#33aadd",
        },
        components: {
          Form: {
            labelColor: "rgb(51, 170, 221)",
            fontSize: 15,
          },
        },
      }}
    >
      <AppContent />
    </ConfigProvider>
  );
};

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
